import { useContext } from "react";
import { ButtonDS, GlobalIcon, IconNameT } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { DataCardI } from "../../../../../../api/request/Payment/Interfaces/PaymentMethodI.response";
import { cardStyle, sectionTitleStyle } from "../cardStyles";

interface PaymentMethodCardProps {
  dataCard: DataCardI | null;
  onChangeMethod: () => void;
}

const PaymentMethodCard = ({ dataCard, onChangeMethod }: PaymentMethodCardProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  const label = dataCard
    ? dataCard.type === "sepa_debit"
      ? `IBAN: **** **** **** ${dataCard.lastFourDigits}`
      : `Visa terminada en ${dataCard.lastFourDigits}`
    : "—";

  const icon: IconNameT =
    dataCard?.type === "sepa_debit" ? "BuildingIcon" : "CreaditCard";

  return (
    <div style={cardStyle}>
      <div style={sectionTitleStyle}>
        <GlobalIcon iconName="CreaditCard" size="XS" color="#4f46e5" />
        <h2 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>
          {translate("newDashboard.billing.paymentMethod")}
        </h2>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          padding: 20,
          backgroundColor: "#f9fafb",
          borderRadius: 10,
          marginBottom: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 48,
            height: 48,
            backgroundColor: "#e0e7ff",
            borderRadius: 12,
            flexShrink: 0,
          }}
        >
          <GlobalIcon iconName={icon} size="XS" color="#4f46e5" />
        </div>
        <div>
          <p style={{ fontSize: 15, fontWeight: 600, color: "#111827", margin: 0 }}>
            {label}
          </p>
          {dataCard && (
            <p style={{ fontSize: 13, color: "#9ca3af", margin: "2px 0 0" }}>
              {dataCard.type === "sepa_debit"
                ? "Domiciliación bancaria"
                : "Tarjeta de crédito"}
            </p>
          )}
        </div>
      </div>
      <ButtonDS
        label={translate("newDashboard.billing.changeMethod")}
        buttonType="secondary"
        size="32"
        onClick={onChangeMethod}
      />
    </div>
  );
};

export default PaymentMethodCard;
